import http from '@/support/plugin/axios'

export const

getSessionByCurrentId = () => http.get('sessions/current')